import { cn } from "utils/cn";

export function FormError(props: React.ComponentPropsWithoutRef<"div">) {
  return (
    <div
      {...props}
      className={cn("font-sans text-sm text-zi-formError", props.className)}
    />
  );
}
